import { Combobox, ComboboxOption } from 'components/ui/combobox';
import { COUNTRIES } from 'constants/countries';
import { Artist } from 'types';
import { useTranslation } from 'react-i18next';

interface LocationStepProps {
  profile: Artist;
  value: string;
  onChange: (value: string) => void;
}

export function LocationStep({ profile, value, onChange }: LocationStepProps) {
  const { t } = useTranslation('collab-club');
  const countryOptions: ComboboxOption[] = COUNTRIES.map((country) => ({
    value: country,
    label: country,
  }));

  return (
    <div className="space-y-6">
      <div className="">
        <h3 className="text-lg font-semibold text-gray-900">{t('select_country')}</h3>
      </div>

      <Combobox
        options={countryOptions}
        value={value}
        onValueChange={(v) => onChange(v as string)}
        placeholder={t('select_placeholder')}
        searchPlaceholder={t('search_placeholder_generic')}
        emptyText={t('nothing_found')}
        multiple={false}
      />
    </div>
  );
}
